import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import UpdateMarket from './UpdateMarket';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message, newItem, selectedItem,
  } = state.market;
  return {
    isLoading,
    data,
    error,
    message,
    newItem,
    selectedItem,
  };
}

const Styled = withStyles(styles)(UpdateMarket);

export default connect(
  mapStateToProps,
)(Styled);
